import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private http: HttpClient) {}

  getNotifications(): Observable<any> {
    return this.http.get<any>(`/admin/notifications/grouped/`);
  }

  getAllNotifications(params): Observable<any> {
    return this.http.get<any>(`/admin/notifications/`, { params: params });
  }

  changeNotificationStatus(data): Observable<any> {
    return this.http.post<any>(`/async/notification/change_status`, data);
  }

  changeNotificationsToReadStatus(data): Observable<any> {
    return this.http.post<any>(`/async/notification/mark_all_as_read`, data);
  }

  getNotificationTypes(): Observable<any> {
    return this.http.get<any>(`/admin/notification_types/`);
  }

  getNotificationsUnion(params) {
    const notifications = this.getAllNotifications(params);
    const getNotificationTypes = this.getNotificationTypes();

    return forkJoin([notifications, getNotificationTypes]);
  }
}
